module.exports = __webpack_public_path__ + "static/media/tools-link.1a211f3c.svg";